<template>
    <card
        v-if="consultations"
        color="blue"
        activated
        class="card-agenda"
        :link="ConsultationlinkObject"
    >
        <agenda-item
            v-for="(agendaItem, index) in items"
            :key="index"
            :agenda-item="agendaItem"
        />
    </card>
    <card v-else color="blue" activated class="card-agenda" :link="linkObject">
        <agenda-item
            v-for="(agendaItem, index) in items"
            :key="index"
            :agenda-item="agendaItem"
        />
    </card>
</template>

<script>
import agendaItem from '@/components/agenda/agenda-item';
import card from '@/components/cards/card';
import translationMixin from '@/mixins/translations';

export default {
    components: {
        agendaItem,
        card
    },

    mixins: [translationMixin],

    props: {
        items: {
            type: Array,
            default: () => []
        },
        link: {
            type: String,
            default: ''
        },
        consultations: Boolean
    },
    computed: {
        ConsultationlinkObject() {
            return {
                text: this.translations.consultationsButton,
                url: this.link
            };
        },
        linkObject() {
            return {
                text: this.translations.agendaButton,
                url: this.link
            };
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .card__text {
    justify-content: start;
}
</style>
